module.exports = __webpack_public_path__ + "static/media/adserver_header_background.2da49b72.png";